import api from './interceptor';

// const BASE_URL_V1 = 'api/v1/chat';
const BASE_URL_V2 = 'api/v2/chat';

export default {
  // API Version 2
  getAllChats: params => api.get(`${BASE_URL_V2}/rooms/my`, { params }),
  getChat: (chatId, params) => api.get(`${BASE_URL_V2}/rooms/${chatId}`, { params }),
  getMessages: (chatId, params) => api.get(`${BASE_URL_V2}/rooms/${chatId}/messages`, { params }),
  getChatExists: userId => api.get(`${BASE_URL_V2}/rooms/exists/${userId}`),
  getChatsRequests: () => api.get(`${BASE_URL_V2}/rooms/approve`),
  reopenChat: (chatId, params) => api.post(`${BASE_URL_V2}/rooms/reopen/${chatId}/`, params),
  createChat: (clinicId, params) => api.post(`${BASE_URL_V2}/${clinicId}/rooms`, params),
  approveChat: chatId => api.post(`${BASE_URL_V2}/rooms/${chatId}/approve`),
  rejectChat: chatId => api.post(`${BASE_URL_V2}/rooms/${chatId}/reject`),
  markAsSeen: chatId => api.post(`${BASE_URL_V2}/rooms/${chatId}/mark-as-seen`),
};
